import jobServices from 'ApiService/Placement/jobServices';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const AllStudents = () => {
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [batches, setBatches] = useState([]);
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [loadingBranch, setloadingBranch] = useState(true);
  const [jobPriorityFilter, setJobPriorityFilter] = useState('all');
  const [locationFilter, setLocationFilter] = useState('all');
  const [salaryFilter, setSalaryFilter] = useState('all');
  const [previewPdf, setPreviewPdf] = useState(null); // State for PDF preview modal
  const [studentDetails, setStudentDetails] = useState([]);
  const [classData, setClassData] = useState({
    courseId: '',
    batchId: '',
  });
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const branchId = selectedBranch || state?.selectedBranch || null;

  const handleViewOfferLetter = (e, filePath) => {
    e.stopPropagation();
    if (!filePath) return;

    try {
      const pdfUrl = `${process.env.REACT_APP_API_BASE_URL.replace(
        '/api/v1',
        ''
      )}/${filePath.replace(/\\/g, '/')}`;
      window.open(pdfUrl, '_blank');
    } catch (error) {
      toast.error('Failed to open PDF');
    }
  };

  const handlePreviewOfferLetter = (e, filePath) => {
    e.stopPropagation();
    if (!filePath) return;

    try {
      const pdfUrl = `${process.env.REACT_APP_API_BASE_URL.replace(
        '/api/v1',
        ''
      )}/${filePath.replace(/\\/g, '/')}`;
      setPreviewPdf(pdfUrl);
    } catch (error) {
      toast.error('Failed to preview PDF');
    }
  };

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    const selectedCourse = courses.find(
      (course) => course.courseId === courseId
    );
    setBatches(selectedCourse?.batches);
    setClassData({ ...classData, courseId, batchId: '' });
  };

  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setClassData({ ...classData, batchId });
  };

  const handleBranchChange = (event) => {
    const branchId = event.target.value;
    console.log(branchId, 'branchId');
    setSelectedBranch(branchId);
  };

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await jobServices.getCourseBatch(branchId || null);

      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        setCourses([]);
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      setCourses([]);
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [branchId]);

  const fetchBranch = async () => {
    setloadingBranch(true);
    try {
      const response = await jobServices.getBranch();
      if (response.data.success) {
        setBranch(response.data.allBranches || []);
      } else {
        toast.error('Failed to fetch Branches.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch Branches.'
      );
    } finally {
      setloadingBranch(false);
    }
  };

  useEffect(() => {
    fetchBranch();
  }, []);

  async function fetchStudents() {
    setLoading(true);
    try {
      const requestData = {};
      if (classData.courseId) {
        requestData.courseId = classData.courseId;
      }
      if (classData.batchId) {
        requestData.batchId = classData.batchId;
      }
      if (selectedBranch) {
        requestData.branchId = selectedBranch;
      }
      const response = await jobServices.getAllPlacedStudents(
        // selectedJob,
        requestData.courseId,
        requestData.batchId,
        requestData.branchId
      );
      if (response.data.success) {
        // setStudentDetails(response.data.data || []);
        const priorityOrder = {
          High: 1,
          Medium: 2,
          Low: 3,
        };
        const studentsWithSelection = response?.data?.data;

        setStudentDetails(studentsWithSelection);
        setLoading(false);
        setLoading(false);
        if (response.data.data.length === 0) {
          toast.error('No students found ');
          setLoading(false);
        }
      } else {
        setStudentDetails([]);
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      setStudentDetails([]);
      toast.error(error?.response?.data?.message);
    }
  }

  useEffect(() => {
    // if (selectedJob) {
    fetchStudents();
    // }
  }, [classData.courseId, classData.batchId, selectedBranch]);

  useEffect(() => {
    let result = [...studentDetails];

    if (searchTerm) {
      result = result.filter(
        (student) =>
          student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.contactNumber.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filter !== 'all') {
      result = result.filter(
        (student) => student.gender.toLowerCase() === filter
      );
    }

    if (jobPriorityFilter !== 'all') {
      result = result.filter(
        (student) =>
          student.placementPriority.toLowerCase() === jobPriorityFilter
      );
    }

    if (locationFilter !== 'all') {
      result = result.filter((student) =>
        student.jobLocationPreference.includes(locationFilter)
      );
    }

    if (salaryFilter !== 'all') {
      result = result.filter(
        (student) => student.preferredSalary === salaryFilter
      );
    }

    setFilteredData(result);
  }, [
    studentDetails,
    filter,
    jobPriorityFilter,
    locationFilter,
    salaryFilter,
    searchTerm,
  ]);

  function resetFilters() {
    setFilteredData(studentDetails);
    setClassData({
      ...classData,
      courseId: '',
      batchId: '',
    });
    setFilteredData([]);
    setFilter('all');
    setSearchTerm('');
    setSelectedBranch('');
    setJobPriorityFilter('all');
    setLocationFilter('all');
    setSalaryFilter('all');
    setStudentDetails([]);
  }

  return (
    <div className="w-full p-4 sm:overflow-auto">
      <div className="p-4">
        {/* Search and Filter Section */}
        <div className="flex flex-col items-center gap-4 sm:flex-row">
          {/* Search Input */}
          <div className="w-full">
            <input
              type="text"
              placeholder="Search by name, email, or company..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-navy-800 dark:text-white"
            />
          </div>

          {/* Priority Filter */}

          {/* Reset Button */}
          <button
            onClick={resetFilters}
            className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600 sm:w-40"
          >
            Reset
          </button>
        </div>

        {/* Filters Section */}
        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* Branch Selection */}
          {state?.user?.role !== 'admin' && (
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700 dark:text-white">
                Select Branch
              </label>
              <select
                onChange={handleBranchChange}
                value={selectedBranch}
                className="w-full rounded-lg border border-gray-200 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-navy-800 dark:text-white"
              >
                <option value="">Select Branch</option>
                {loadingBranch ? (
                  <option>Loading Branch...</option>
                ) : branch.length === 0 ? (
                  <option className="text-blue-600">No Branch available</option>
                ) : (
                  branch.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name} ({item.location})
                    </option>
                  ))
                )}
              </select>
            </div>
          )}

          {/* Course Selection */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-white">
              Select Course
            </label>
            <select
              onChange={handleCourseChange}
              value={classData?.courseId}
              className="w-full rounded-lg border border-gray-200 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="">Select Course</option>
              {loadingCourses ? (
                <option>Loading courses...</option>
              ) : courses.length === 0 ? (
                <option className="text-blue-600">No courses available</option>
              ) : (
                courses.map((course, i) => (
                  <option key={course.courseId} value={course.courseId}>
                    {i + 1}. {course.courseName}
                  </option>
                ))
              )}
            </select>
          </div>

          {/* Batch Selection */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-white">
              Select Batch
            </label>
            <select
              onChange={handleBatchChange}
              value={classData.batchId}
              className="w-full rounded-lg border border-gray-200 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="">Select Batch</option>
              {batches.length > 0 ? (
                batches.map((batch) => (
                  <option key={batch._id} value={batch._id}>
                    Batch {batch.batchNumber} - From{' '}
                    {new Date(batch.startDate).toLocaleDateString()} to{' '}
                    {new Date(batch.endDate).toLocaleDateString()}
                  </option>
                ))
              ) : (
                <option>No batches available</option>
              )}
            </select>
          </div>

          {/* Salary Filter */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-white">
              Salary Preference
            </label>
            <select
              value={salaryFilter}
              onChange={(e) => setSalaryFilter(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="all">All Salaries</option>
              <option value="Any Salary">Any Salary</option>
              <option value="Below 3 LPA">Below 3 LPA</option>
              <option value="Below 4 LPA">Below 4 LPA</option>
              <option value="Below 5 LPA">Below 5 LPA</option>
              <option value="More than 5 LPA">More than 5 LPA</option>
            </select>
          </div>
        </div>

        {/* Table Section */}
        {loading ? (
          <div className="flex h-40 items-center justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <div className="mt-8 overflow-x-auto">
            {filteredData.length === 0 ? (
              <div className="py-8 text-center text-gray-500 dark:text-gray-400">
                No placed students found
              </div>
            ) : (
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead>
                  <tr>
                    {[
                      'Name',
                      'Total Offers',
                      'Offers',
                      'Salary',
                      'Preferred Salary',
                      'Location',
                      'Joining Date',
                      'Bond Duration',
                      'Benefits',
                      'View Offer Letter',
                    ].map((header) => (
                      <th
                        key={header}
                        className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                  {filteredData.map((student) => (
                    <tr
                      key={student._id}
                      className="hover:bg-gray-50 dark:hover:bg-gray-800"
                    >
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        {student.name}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        {student.placementInfo.totalOffers}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.companyName || '-'} (
                                {offer.jobTitle || '-'})
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.offerDetails?.salary
                                  ? `₹${offer.offerDetails.salary.toLocaleString()}`
                                  : '-'}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`rounded-full px-2 py-1 text-xs font-semibold ${
                            student.preferredSalary === 'More than 5 LPA'
                              ? 'bg-green-100 text-green-700'
                              : student.preferredSalary === 'Below 5 LPA'
                              ? 'bg-blue-100 text-blue-700'
                              : student.preferredSalary === 'Below 4 LPA'
                              ? 'bg-yellow-100 text-yellow-700'
                              : student.preferredSalary === 'Below 3 LPA'
                              ? 'bg-orange-100 text-orange-700'
                              : 'bg-gray-100 text-gray-700'
                          }`}
                        >
                          {student.preferredSalary || 'Any Salary'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.offerDetails?.location || '-'}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.offerDetails?.joiningDate
                                  ? new Date(
                                      offer.offerDetails.joiningDate
                                    ).toLocaleDateString()
                                  : '-'}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.offerDetails?.bondDuration
                                  ? `${offer.offerDetails.bondDuration} months`
                                  : '-'}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-${index}`}>
                                {offer.offerDetails?.benefits?.length
                                  ? offer.offerDetails.benefits.join(', ')
                                  : '-'}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                        <ul>
                          {student.placementInfo.allOffers.map(
                            (offer, index) => (
                              <li key={`${student._id}-offer-${index}`}>
                                {offer.offerDetails?.offerLetterFilePath ? (
                                  <div className="flex items-center space-x-2">
                                    <button
                                      onClick={(e) =>
                                        handleViewOfferLetter(
                                          e,
                                          offer.offerDetails.offerLetterFilePath
                                        )
                                      }
                                      className="rounded bg-green-500 px-3 py-1 text-xs text-white hover:bg-green-600"
                                      title={
                                        offer.offerDetails
                                          .offerLetterFileName || 'Offer Letter'
                                      }
                                    >
                                      View PDF
                                    </button>
                                    <button
                                      onClick={(e) =>
                                        handlePreviewOfferLetter(
                                          e,
                                          offer.offerDetails.offerLetterFilePath
                                        )
                                      }
                                      className="rounded bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
                                      title="Preview PDF"
                                    >
                                      Preview
                                    </button>
                                  </div>
                                ) : (
                                  'Not Available'
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {/* PDF Preview Modal */}
      {previewPdf && (
        <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
          <div className="relative w-full max-w-4xl rounded-lg bg-white p-4 dark:bg-navy-800">
            <button
              onClick={() => setPreviewPdf(null)}
              className="absolute right-2 top-2 rounded-full bg-gray-200 p-1 text-gray-700 hover:bg-gray-300 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
              Offer Letter Preview
            </h3>
            <iframe
              src={`${previewPdf}#toolbar=1`}
              width="100%"
              height="500"
              className="rounded border border-gray-300"
              title="Offer Letter PDF"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AllStudents;
